import ProcessActionRoutes from '../constants/process_action_routes';

import RestClient from 'rest_client/rest_client';
import ResponseHandler from 'rest_client/response_handler';
import FormStore from 'form/reflux/form_store';
import FormValuesSerializer from 'serializers/form_values_serializer';
import { serializePrivateProperties } from 'utils/object_utils';

export const execute = (storeItem) => {
	const url = ProcessActionRoutes.SAVE_ACTIVITY;
	const params = buildRequestParams(storeItem);

	return new Promise((resolve, reject) => {
		return RestClient.post(url, params)
		.then(handleLoadSuccess.bind(this, resolve))
		.catch(handleLoadError.bind(this, reject));
	});
};

const buildRequestParams = (storeItem) => {
	const { formStoreId, processIds } = storeItem;
	const formId = FormStore.store[formStoreId]['id'];

	return Object.assign({
		data: FormValuesSerializer.serialize({ formId })
	}, serializePrivateProperties(processIds));
};

const handleLoadSuccess = (resolve, response) => {
	ResponseHandler.displaySuccessActionFlashMessage('saveActivity', 'flash-form');
	resolve(response);
};

const handleLoadError = (reject, reason) => {
	ResponseHandler.displayErrorResponseFlashMessage('flash-form', reason);
	reject(reason);
};

export default {
	execute
};
